import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Table, { ColumnDefinitionType } from "../../../../../components/Table";
import { Loading } from "../../../../../components/Loading";
import MyModal from "../../../../../components/Modal";
import Confirm from "../../../../../components/Confirm";
import FormSelectBox from "../../../../../components/Form/FormSelectBox";
import FormInput from "../../../../../components/Form/FormInput";
import { cargarCombo } from "../../../../../services/Service";
import { AreaEmpresa } from "../../../../../types/AreaEmpresa";
import ModalArea from "./ModalArea";


type AreasProps = {
    areas: AreaEmpresa[],
    setAreas: (value: AreaEmpresa[]) => void,
    edit: boolean,
    view: boolean,
    loading?: boolean,
}

type FormErrors = {
    email?: string;
};

// Mismo criterio que Usuario y Contratista
const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

const areaInicial: AreaEmpresa = {
    idArea: 0,
    nombreArea: '',
    email: '',
    activo: true,
}

const SeccionAreas = ({ edit, view, areas, setAreas, loading = false }: AreasProps) => {
    const [areasCatalogo, setAreasCatalogo] = useState<any[]>([]);
    const [areasDisponibles, setAreasDisponibles] = useState<any[]>([]);
    const [idAreaSeleccionada, setIdAreaSeleccionada] = useState<any>('');
    const [emailNuevo, setEmailNuevo] = useState<string>('');
    const [isOpen, setIsOpen] = useState(false);
    const toggleModal = () => setIsOpen(!isOpen);
    const [showModal, setShowModal] = useState<boolean>(false);
    const toggle = () => setShowModal(!showModal);
    const [modoModal, setModoModal] = useState<'vista' | 'edicion'>('edicion');
    const [areaForm, setAreaForm] = useState<AreaEmpresa>(areaInicial);
    const [data, setData] = useState<AreaEmpresa>(areaInicial);
    const [formErrors, setFormErrors] = useState<FormErrors>({ email: '' });

    useEffect(() => {
        cargarCombo('areas/findBy?activo=true', setAreasCatalogo);
    }, [])

    useEffect(() => {
        const disponibles = (areasCatalogo || []).filter(
            (a: any) => !areas.some(asociada => asociada.idArea === a.id)
        );
        setAreasDisponibles(disponibles);
    }, [areasCatalogo, areas])

    const agregar = () => {
        if (!idAreaSeleccionada) {
            toast.error('Debe seleccionar un Área');
            return;
        }
        if (!emailNuevo.trim()) {
            toast.error('Debe informar el campo Mail');
            return;
        }
        if (!EMAIL_REGEX.test(emailNuevo.trim())) {
            toast.error('El campo Mail no tiene un formato válido');
            return;
        }
        if (areas.some(a => a.idArea === Number(idAreaSeleccionada))) {
            toast.error('El área seleccionada ya se encuentra asociada');
            return;
        }
        const areaCatalogo = areasCatalogo.find((a: any) => a.id === Number(idAreaSeleccionada));
        if (areaCatalogo) {
            const nuevaArea: AreaEmpresa = {
                idArea: areaCatalogo.id,
                nombreArea: areaCatalogo.nombre,
                email: emailNuevo.trim(),
                activo: true,
            }
            setAreas([...areas, nuevaArea]);
            setIdAreaSeleccionada('');
            setEmailNuevo('');
        }
    }

    const eliminar = () => {
        setAreas(areas.filter(a => a.idArea !== data.idArea));
        toggle();
    }

    const handleConfirm = () => {
        const errors: FormErrors = {};
        if (!areaForm.email || !areaForm.email.trim()) {
            errors.email = 'El campo Mail es obligatorio';
        } else if (!EMAIL_REGEX.test(areaForm.email.trim())) {
            errors.email = 'El campo Mail no tiene un formato válido';
        }
        if (Object.keys(errors).length === 0) {
            setAreas(areas.map(a => a.idArea === areaForm.idArea ? { ...areaForm, email: areaForm.email.trim() } : a));
            toggleModal();
        }
        setFormErrors(errors);
    }

    const columns: ColumnDefinitionType<AreaEmpresa, keyof AreaEmpresa>[] = []
    columns.push({
        key: 'nombreArea',
        header: 'Área',
    });
    columns.push({
        key: 'email',
        header: 'Mail',
    });
    columns.push({
        key: 'idArea',
        header: 'Acciones',
        cell: (data: AreaEmpresa) =>
            <>
                <Link to="#" title="Vista"
                    onClick={(e) => {
                        e.stopPropagation();
                        setAreaForm(data);
                        setModoModal('vista');
                        setFormErrors({ email: '' });
                        toggleModal();
                    }}
                >
                    <i className="fa fa-eye text-secondary me-2" aria-hidden="true"></i>
                </Link>
                {!view &&
                    <>
                        <Link to="#" title="Editar"
                            onClick={(e) => {
                                e.stopPropagation();
                                setAreaForm(data);
                                setModoModal('edicion');
                                setFormErrors({ email: '' });
                                toggleModal();
                            }}
                        >
                            <i className="fa fa-pencil text-custom" aria-hidden="true"></i>
                        </Link>

                        <Link to="#" title="eliminar"
                            onClick={(e) => {
                                e.stopPropagation();
                                setData(data);
                                setShowModal(true)
                            }}
                        >
                            <i className="fa fa-trash-o mr-2 text-danger" aria-hidden="true"></i>
                        </Link>
                    </>
                }
            </>
    });

    const esVista = modoModal === 'vista';

    return (
        <>
            <Confirm isOpen={showModal} toggle={toggle} title='Eliminar' yesFn={eliminar}>
                <div className="form-horizontal">
                    <div className="row">
                        {<p>Está seguro que desea eliminar el área {data.nombreArea}?</p>}
                    </div>
                </div>
            </Confirm>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        {!view &&
                            <div className="row mt-2 mb-3">
                                <FormSelectBox
                                    title={'Área'}
                                    label={'Área'}
                                    id={'idArea'}
                                    name={'idArea'}
                                    onChange={(e) => setIdAreaSeleccionada(e.target.value)}
                                    optionId={'id'}
                                    optionLabel={'nombre'}
                                    value={idAreaSeleccionada}
                                    options={areasDisponibles}
                                    isDisabled={edit && view}
                                />
                                <FormInput
                                    id={'emailNuevo'}
                                    label={'Mail'}
                                    name={'emailNuevo'}
                                    value={emailNuevo}
                                    onChange={(e) => setEmailNuevo(e.target.value)}
                                    type='email'
                                    maxLength={100}
                                />
                            </div>
                        }

                        <h4 className="m-t-0 header-title">
                            Áreas
                            {!view &&
                                <Link to="#" title="Agregar" className="btn-custom btn-rounded waves-effect waves-light pull-right btn-sm" style={{ marginTop: '-8px' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        agregar();
                                    }}>
                                    <i className="fa fa-plus margin-right-10"></i> Agregar
                                </Link>
                            }
                        </h4>

                        <div className="table-responsive">
                            <br />
                            <MyModal isOpen={isOpen} toggle={toggleModal} title={esVista ? 'Vista Área' : 'Editar Área'} size="md"
                                secondButton={!esVista} secondButtonTitle={'Aceptar'} titleCancelar={esVista ? 'Volver' : 'Cancelar'} secondButtonFn={handleConfirm}
                            >
                                <ModalArea areaForm={areaForm} setAreaForm={setAreaForm} formErrors={formErrors} soloLectura={esVista} />
                            </MyModal>
                            {loading ? <Loading /> : <Table data={areas || []} columns={columns}></Table>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SeccionAreas;
